import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { DynamoUtilityRequest, DynamoUtilityResponse } from "../../Models/DynamoUtility";

@Injectable({
  providedIn: "root",
})
export class DynamoUtilityService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, @Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}

  getTables(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/dynamo-utility/tables`, { headers: this.authHeaders() });
  }

  execute(payload: DynamoUtilityRequest): Observable<DynamoUtilityResponse> {
    return this.http.post<DynamoUtilityResponse>(`${this.apiUrl}/dynamo-utility/execute`, payload, { headers: this.authHeaders() });
  }

  // The API checks this Okta access token and its users_csp_admin group; the user is identified from the token, not the payload
  private authHeaders(): HttpHeaders {
    const token = this.oktaAuth.getAccessToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
